// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { db, auth } from '../firebase.js';
// import { doc, updateDoc, getDoc } from 'firebase/firestore';
// import Sidebar from '../components/Sidebar.jsx';
// import Header from '../components/Header.jsx';

// const SettingsPage = () => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const queryParams = new URLSearchParams(location.search);
//     const shop = queryParams.get('shop'); // Assuming shop name is passed in the URL as a query parameter

//     const [ifscCode, setIfscCode] = useState('');
//     const [branch, setBranch] = useState('');
//     const [name, setName] = useState('');
//     const [accountNumber, setAccountNumber] = useState('');
//     const [error, setError] = useState('');
//     const [success, setSuccess] = useState('');
//     const [isLoading, setIsLoading] = useState(true);


//         const user = auth.currentUser;
//         if (!user) {
//           throw new Error("User not logged in");
//         }

//     // Fetch existing shop details if available
//     useEffect(() => {
//         const fetchShopDetails = async () => {
//             try {
//                 const userRef = doc(db, 'users', user.uid);
//                 const userDoc = await getDoc(userRef);

//                 if (userDoc.exists()) {
//                     // You can prefill the form with existing account info if it exists
//                     const userData = userDoc.data();
//                     setName(userData.name || '');
//                     setIfscCode(userData.ifscCode || '');
//                     setBranch(userData.branch || '');
//                     setAccountNumber(userData.accountNumber || '');
//                 }

//                 setIsLoading(false);
//             } catch (err) {
//                 console.error('Error fetching shop details:', err);
//                 setIsLoading(false);
//             }
//         };

//         if (user) {
//             fetchShopDetails();
//         } else {
//             setError('user not found.');
//             setIsLoading(false);
//         }
//     }, [user]);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError('');
//         setSuccess('');

//         if (!user) {
//             setError('User name is required.');
//             return;
//         }

//         try {
//             const userRef = doc(db, 'users', user.uid);

//             // Update the shop document with the new account information
//             await updateDoc(userRef, {
//                 name,
//                 ifscCode,
//                 branch,
//                 accountNumber,
//             });

//             setSuccess('Account info updated successfully!');
//         } catch (err) {
//             console.error('Error updating account info:', err);
//             setError('An error occurred. Please try again.');
//         }
//     };

//     if (isLoading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div className="products-page">
//             <Header />
//             <div className="products-container">
//                 <Sidebar />
//                 <div className="main-content">
//                     <h1>Account Settings</h1>
//                     <form onSubmit={handleSubmit} className="settings-form">

//                     <label>
//                            Name:
//                             <input
//                                 type="text"
//                                 value={name}
//                                 onChange={(e) => setName(e.target.value)}
//                                 required
//                             />
//                         </label>
//                         <label>
//                             IFSC Code:
//                             <input
//                                 type="text"
//                                 value={ifscCode}
//                                 onChange={(e) => setIfscCode(e.target.value)}
//                                 required
//                             />
//                         </label>
//                         <label>
//                             Branch:
//                             <input
//                                 type="text"
//                                 value={branch}
//                                 onChange={(e) => setBranch(e.target.value)}
//                                 required
//                             />
//                         </label>
//                         <label>
//                             Account Number:
//                             <input
//                                 type="text"
//                                 value={accountNumber}
//                                 onChange={(e) => setAccountNumber(e.target.value)}
//                                 required
//                             />
//                         </label>

//                         <button type="submit" className="save-button">Save</button>

//                         {error && <p className="error">{error}</p>}
//                         {success && <p className="success">{success}</p>}
//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SettingsPage;

// import React, { useState, useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { db, auth } from '../firebase.js';
// import { doc, updateDoc, getDoc } from 'firebase/firestore';
// import Sidebar from '../components/Sidebar.jsx';
// import Header from '../components/Header.jsx';
// import '../style/setting.css'

// const SettingsPage = () => {
//     const [activeTab, setActiveTab] = useState('account'); // Manage active tab
//     const [ifscCode, setIfscCode] = useState('');
//     const [branch, setBranch] = useState('');
//     const [name, setName] = useState('');
//     const [accountNumber, setAccountNumber] = useState('');
//     const [codCharges, setCodCharges] = useState('');
//     const [error, setError] = useState('');
//     const [success, setSuccess] = useState('');
//     const [isLoading, setIsLoading] = useState(true);

//     const user = auth.currentUser;
//     if (!user) {
//         throw new Error("User not logged in");
//     }

//     useEffect(() => {
//         const fetchUserDetails = async () => {
//             try {
//                 const userRef = doc(db, 'users', user.uid);
//                 const userDoc = await getDoc(userRef);
//                 if (userDoc.exists()) {
//                     const userData = userDoc.data();
//                     setName(userData.name || '');
//                     setIfscCode(userData.ifscCode || '');
//                     setBranch(userData.branch || '');
//                     setAccountNumber(userData.accountNumber || '');
//                     setCodCharges(userData.codCharges || '');
//                 }
//                 setIsLoading(false);
//             } catch (err) {
//                 console.error('Error fetching user details:', err);
//                 setIsLoading(false);
//             }
//         };

//         fetchUserDetails();
//     }, [user]);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError('');
//         setSuccess('');

//         try {
//             const userRef = doc(db, 'users', user.uid);
//             await updateDoc(userRef, {
//                 name,
//                 ifscCode,
//                 branch,
//                 accountNumber,
//                 codCharges: Number(codCharges)
//             });
//             setSuccess('Settings updated successfully!');
//         } catch (err) {
//             console.error('Error updating settings:', err);
//             setError('An error occurred. Please try again.');
//         }
//     };

//     if (isLoading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div className="products-page">
//             <Header />
//             <div className="products-container">
//                 <Sidebar />
//                 <div className="main-content">
//                     <h1>Settings</h1>
//                     <div className="tabs">
//                         <button onClick={() => setActiveTab('account')} className={activeTab === 'account' ? 'active' : ''}>Bank Account</button>
//                         <button onClick={() => setActiveTab('codCharges')} className={activeTab === 'codCharges' ? 'active' : ''}>COD Charges</button>
//                     </div>
                    
//                     {activeTab === 'account' && (
                        
//                         <form onSubmit={handleSubmit} className="settings-form">
//                             <p>Enter your bank details to receive COD payouts directly to your account.</p>
//                             <label>
//                                 Name:
//                                 <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
//                             </label>
//                             <label>
//                                 IFSC Code:
//                                 <input type="text" value={ifscCode} onChange={(e) => setIfscCode(e.target.value)} required />
//                             </label>
//                             <label>
//                                 Branch:
//                                 <input type="text" value={branch} onChange={(e) => setBranch(e.target.value)} required />
//                             </label>
//                             <label>
//                                 Account Number:
//                                 <input type="text" value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} required />
//                             </label>
//                             <button type="submit" className="save-button">Save</button>
//                         </form>
//                     )}
                    
//                     {activeTab === 'codCharges' && (
//                         <form onSubmit={handleSubmit} className="settings-form">
//                             <p>Charge an extra amount on manual COD orders and have it collected at delivery.</p>
//                             <label>
//                                 COD Charges:
//                                 <input
//     type="number"
//     value={codCharges}
//     onChange={(e) => setCodCharges(Number(e.target.value))} // Convert input value to number
//     required
// />
//                             </label>
//                             <button type="submit" className="save-button">Save</button>
//                         </form>
//                     )}

//                     {error && <p className="error">{error}</p>}
//                     {success && <p className="success">{success}</p>}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SettingsPage;


import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { db, auth } from '../firebase.js';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import Sidebar from '../components/Sidebar.jsx';
import Header from '../components/Header.jsx';
import '../style/Order.css';
import { toast } from 'react-toastify';
import { FaTruck, FaPlane } from 'react-icons/fa';


const SettingsPage = () => {
    const [activeTab, setActiveTab] = useState('billing'); // Changed default to billing
    const [ifscCode, setIfscCode] = useState('');
    const [branch, setBranch] = useState('');
    const [name, setName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [codCharges, setCodCharges] = useState('');
    const [shippingPreference, setShippingPreference] = useState('Surface'); // Default to Surface
    
    // New billing details state
    const [gstNumber, setGstNumber] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [pincode, setPincode] = useState('');
    
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const user = auth.currentUser;
    if (!user) {
        throw new Error("User not logged in");
    }

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const userRef = doc(db, 'users', user.uid);
                const userDoc = await getDoc(userRef);
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    setName(userData.name || '');
                    setIfscCode(userData.ifscCode || '');
                    setBranch(userData.branch || '');
                    setAccountNumber(userData.accountNumber || '');
                    setCodCharges(userData.codCharges || '');
                    setShippingPreference(userData.shippingPreference || 'Surface'); // Default to Surface if not set
                    
                    // Set billing details
                    setGstNumber(userData.gstNumber || '');
                    setAddress(userData.address || '');
                    setCity(userData.city || '');
                    setState(userData.state || '');
                    setPincode(userData.pincode || '');
                }
                setIsLoading(false);
            } catch (err) {
                console.error('Error fetching user details:', err);
                setIsLoading(false);
            }
        };

        fetchUserDetails();
    }, [user]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const userRef = doc(db, 'users', user.uid);
            const updateData = {};
            
            // Only update fields based on active tab
            if (activeTab === 'billing') {
                updateData.gstNumber = gstNumber;
                updateData.address = address;
                updateData.city = city;
                updateData.state = state;
                updateData.pincode = pincode;
            } else if (activeTab === 'account') {
                updateData.name = name;
                updateData.ifscCode = ifscCode;
                updateData.branch = branch;
                updateData.accountNumber = accountNumber;
            } else if (activeTab === 'codCharges') {
                updateData.codCharges = Number(codCharges);
            } else if (activeTab === 'shipping') {
                updateData.shippingPreference = shippingPreference;
            }

            await updateDoc(userRef, updateData);
            toast.success('Settings updated successfully!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } catch (err) {
            console.error('Error updating settings:', err);
            setError('An error occurred. Please try again.');
        }
    };

    if (isLoading) {
        return (
            <div className="flex h-screen bg-white">
                <Sidebar />
                <div className="flex-1 flex flex-col min-w-0 overflow-hidden md:ml-64">
                    <Header />
                    <div className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto flex items-center justify-center">
                        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8 text-center max-w-md">
                            <div className="w-16 h-16 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
                                <svg className="w-8 h-8 text-gray-400 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">Loading...</h2>
                            <p className="text-gray-600">Loading your settings.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="flex h-screen bg-white">
            <Sidebar />
            <div className="flex-1 flex flex-col min-w-0 overflow-hidden md:ml-64">
                <Header />
                <div className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
                    <div className="max-w-4xl mx-auto">
                        {/* Header Section */}
                        <div className="mb-8">
                            <h1 className="text-3xl font-bold text-gray-900 mb-2 create-order-title">Settings</h1>
                            <p className="text-gray-600 text-lg">Manage your account settings and preferences</p>
                        </div>

                        {/* Tab Navigation */}
                        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-2 mb-8">
                            <div className="grid grid-cols-2 md:flex md:flex-wrap gap-2">
                                {[
                                    { 
                                        id: 'billing', 
                                        label: 'Billing Details', 
                                        shortLabel: 'Billing',
                                        icon: (
                                            <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                        )
                                    },
                                    { 
                                        id: 'account', 
                                        label: 'Bank Account', 
                                        shortLabel: 'Bank',
                                        icon: (
                                            <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                            </svg>
                                        )
                                    },
                                    { 
                                        id: 'codCharges', 
                                        label: 'COD Charges', 
                                        shortLabel: 'COD',
                                        icon: (
                                            <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                                            </svg>
                                        )
                                    },
                                    { 
                                        id: 'shipping', 
                                        label: 'Shipping Preferences', 
                                        shortLabel: 'Shipping',
                                        icon: (
                                            <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                            </svg>
                                        )
                                    }
                                ].map((tab) => (
                                    <button
                                        key={tab.id}
                                        onClick={() => setActiveTab(tab.id)}
                                        className={`flex flex-col md:flex-row items-center justify-center gap-1 md:gap-2 px-3 md:px-6 py-3 rounded-xl font-semibold transition-all duration-200 text-xs md:text-sm ${
                                            activeTab === tab.id
                                                ? 'bg-black text-white shadow-lg'
                                                : 'text-gray-600 bg-white hover:text-blue-600 hover:bg-blue-50'
                                        }`}
                                    >
                                        {tab.icon}
                                        <span className="hidden md:inline">{tab.label}</span>
                                        <span className="md:hidden">{tab.shortLabel}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    
                        {/* Billing Details Tab */}
                        {activeTab === 'billing' && (
                            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6">
                                <div className="flex justify-between items-start mb-6">
                                    <div>
                                        <h2 className="text-2xl font-bold text-gray-900 mb-2 create-order-subtitle">Billing Details</h2>
                                        <p className="text-gray-600">Enter your billing details for invoices and records.</p>
                                    </div>
                                    <button 
                                        type="submit" 
                                        form="billing-form"
                                        className="bg-black hover:bg-gray-800 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg"
                                    >
                                        Save
                                    </button>
                                </div>
                                
                                <form id="billing-form" onSubmit={handleSubmit} className="space-y-4">
                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                        <div>
                                            <label htmlFor="gstNumber" className="block text-sm font-medium text-gray-700 mb-1">
                                                GST Number (Optional)
                                            </label>
                                            <input
                                                id="gstNumber"
                                                type="text"
                                                value={gstNumber}
                                                onChange={(e) => setGstNumber(e.target.value)}
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200"
                                                placeholder="Enter GST number"
                                            />
                                        </div>
                                        
                                        <div>
                                            <label htmlFor="pincode" className="block text-sm font-medium text-gray-700 mb-1">
                                                Pincode *
                                            </label>
                                            <input
                                                id="pincode"
                                                type="text"
                                                value={pincode}
                                                onChange={(e) => setPincode(e.target.value)}
                                                required
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200"
                                                placeholder="Enter pincode"
                                            />
                                        </div>
                                    </div>
                                    
                                    <div>
                                        <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1">
                                            Address *
                                        </label>
                                        <textarea
                                            id="address"
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            required
                                            rows={2}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200 resize-none"
                                            placeholder="Enter your complete address"
                                        />
                                    </div>
                                    
                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                        <div>
                                            <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
                                                City *
                                            </label>
                                            <input
                                                id="city"
                                                type="text"
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                                required
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200"
                                                placeholder="Enter city"
                                            />
                                        </div>
                                        
                                        <div>
                                            <label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-1">
                                                State *
                                            </label>
                                            <input
                                                id="state"
                                                type="text"
                                                value={state}
                                                onChange={(e) => setState(e.target.value)}
                                                required
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200"
                                                placeholder="Enter state"
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}

                        {/* Bank Account Tab */}
                        {activeTab === 'account' && (
                            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6">
                                <div className="flex justify-between items-start mb-6">
                                    <div>
                                        <h2 className="text-2xl font-bold text-gray-900 mb-2 create-order-subtitle">Bank Account</h2>
                                        <p className="text-gray-600">Enter your bank details to receive COD payouts directly to your account.</p>
                                    </div>
                                    <button 
                                        type="submit" 
                                        form="account-form"
                                        className="bg-black hover:bg-gray-800 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg"
                                    >
                                        Save
                                    </button>
                                </div>
                                
                                <form id="account-form" onSubmit={handleSubmit} className="space-y-4">
                                    <div>
                                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                                            Account Holder Name *
                                        </label>
                                        <input
                                            id="name"
                                            type="text"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200"
                                            placeholder="Enter account holder name"
                                        />
                                    </div>
                                    
                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                        <div>
                                            <label htmlFor="accountNumber" className="block text-sm font-medium text-gray-700 mb-1">
                                                Account Number *
                                            </label>
                                            <input
                                                id="accountNumber"
                                                type="text"
                                                value={accountNumber}
                                                onChange={(e) => setAccountNumber(e.target.value)}
                                                required
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200"
                                                placeholder="Enter account number"
                                            />
                                        </div>
                                        
                                        <div>
                                            <label htmlFor="ifscCode" className="block text-sm font-medium text-gray-700 mb-1">
                                                IFSC Code *
                                            </label>
                                            <input
                                                id="ifscCode"
                                                type="text"
                                                value={ifscCode}
                                                onChange={(e) => setIfscCode(e.target.value)}
                                                required
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200"
                                                placeholder="Enter IFSC code"
                                            />
                                        </div>
                                    </div>
                                    
                                    <div>
                                        <label htmlFor="branch" className="block text-sm font-medium text-gray-700 mb-1">
                                            Branch *
                                        </label>
                                        <input
                                            id="branch"
                                            type="text"
                                            value={branch}
                                            onChange={(e) => setBranch(e.target.value)}
                                            required
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200"
                                            placeholder="Enter branch name"
                                        />
                                    </div>
                                </form>
                            </div>
                        )}
                    
                        {/* COD Charges Tab */}
                        {activeTab === 'codCharges' && (
                            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6">
                                <div className="flex justify-between items-start mb-6">
                                    <div>
                                        <h2 className="text-2xl font-bold text-gray-900 mb-2 create-order-subtitle">COD Charges</h2>
                                        <p className="text-gray-600">Charge an extra amount on manual COD orders and have it collected at delivery.</p>
                                    </div>
                                    <button 
                                        type="submit" 
                                        form="cod-form"
                                        className="bg-black hover:bg-gray-800 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg"
                                    >
                                        Save
                                    </button>
                                </div>
                                
                                <form id="cod-form" onSubmit={handleSubmit} className="space-y-4">
                                    <div className="max-w-md">
                                        <label htmlFor="codCharges" className="block text-sm font-medium text-gray-700 mb-1">
                                            COD Charges (₹) *
                                        </label>
                                        <div className="relative">
                                            <div className="absolute inset-y-0 left-0 pl-3 my-2 flex items-center pointer-events-none">
                                                <span className="text-gray-500 text-lg ">₹</span>
                                            </div>
                                            <input
                                                id="codCharges"
                                                type="number"
                                                value={codCharges}
                                                onChange={(e) => setCodCharges(Number(e.target.value))}
                                                required
                                                min="0"
                                                step="1"
                                                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-black transition-all duration-200"
                                                placeholder="0"
                                            />
                                        </div>
                                        <p className="text-sm text-gray-500 mt-2">
                                            This amount will be added to COD orders and collected from customers at delivery.
                                        </p>
                                    </div>
                                </form>
                            </div>
                        )}

                        {/* Shipping Preferences Tab */}
                        {activeTab === 'shipping' && (
                            <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-6">
                                <div className="flex justify-between items-start mb-6">
                                    <div>
                                        <h2 className="text-2xl font-bold text-gray-900 mb-2 create-order-subtitle">Shipping Preferences</h2>
                                        <p className="text-gray-600">Choose your preferred shipping method for orders.</p>
                                    </div>
                                    <button 
                                        type="submit" 
                                        form="shipping-form"
                                        className="bg-black hover:bg-gray-800 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg"
                                    >
                                        Save
                                    </button>
                                </div>
                                
                                <form id="shipping-form" onSubmit={handleSubmit} className="space-y-4">
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Shipping Method</h3>
                                        <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4 py-4">
                                            {[
                                                {
                                                    label: 'Surface',
                                                    icon: <FaTruck className="w-4 h-4 md:w-5 md:h-5 mr-2" />
                                                },
                                                {
                                                    label: 'Air',
                                                    icon: <FaPlane className="w-4 h-4 md:w-5 md:h-5 mr-2" />
                                                }
                                            ].map(({ label, icon }) => (
                                                <div
                                                    key={label}
                                                    onClick={() => setShippingPreference(label)}
                                                    className={`flex items-center justify-center cursor-pointer px-4 py-3 md:py-4 rounded-full border transition-all duration-300 w-full text-center text-sm md:text-base ${
                                                        shippingPreference === label
                                                            ? "bg-blue-500 text-white border-blue-500"
                                                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                                                    }`}
                                                >
                                                    {icon}
                                                    <span>{label}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}

                        {/* Error Messages */}
                        {error && (
                            <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6">
                                <div className="flex items-center">
                                    <svg className="w-5 h-5 text-red-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <p className="text-red-800 font-medium">{error}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;